<template>
  <slot v-bind="{ before, success, error }"></slot>
</template>

<script>
import { saveAs } from 'file-saver'
import Toast from '@/frontapp/mixins/actions/Toast'

let lastToast

export default {
  methods: {
    before () {
      lastToast = Toast(
        'info',
        this.$t('Your pdf is generating, it can take a while ..'),
        null,
        false
      )

      this.$store.dispatch('nette/updateControl', {
        controlName: 'exportToPdfForm',
        data: false,
        key: 'showModal'
      })
    },
    success (payload) {
      lastToast.dismiss()
      saveAs(payload.$controls.exportToPdfForm.downloadUrl, payload.$controls.exportToPdfForm.fileName)
    },
    error () {
      lastToast.dismiss()
      Toast(
        'error',
        this.$t('Generating pdf failed, please contact us!'),
      )
    }
  }
}
</script>